import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import onboardingInfoBox from 'contest/components/onboarding-prompts/onboardingInfoBox';

export default onboardingInfoBox('good-designs', () => (
    <div className="info-box__content">
        <p className="paragraph paragraph--wide">
            <FormattedHTMLMessage id="infobox_text" />
        </p>
        <FormattedHTMLMessage id="infobox_link" />
    </div>
));



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/GoodDesignsInfoBox.js